module.exports = __webpack_public_path__ + "img/album19_07.aeab5bfe.jpg";